<div class="card card-grey card-form" fileDnd (fileDropped)="!isLoading && pictureDropped($event)">
  <div id="avatar-wrapper">
    <msd-avatar [src]="(accountStatus$|async)?.dietitian?.picture?.url"
      [text]="(accountStatus$|async)?.dietitian?.initials"></msd-avatar>
    <input #imageInput hidden type="file" accept="image/*" (change)="pictureSelected($event)">
    <button id="change-picture-button" type="button" [disabled]="isLoading" (click)="imageInput.click()"
      class="btn btn-primary btn-gradient text-icon d-inline-flex">
      <ng-container *ngIf="isLoading; else pictureButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #pictureButton>
        <span class="mobile">Photo</span>
        <span class="desktop">Changer de photo</span>
        <i i-bs name="plus" width="20" height="20"></i>
      </ng-template>
    </button>
    <button id="delete-picture-button" type="button" (click)="deletePicture()"
      [disabled]="isLoading || (accountStatus$|async)?.dietitian?.picture?.url == null"
      class="btn btn-outline btn-outline-primary desktop">
      Supprimer
      <i i-bs name="x" width="20" height="20"></i>
    </button>
  </div>
  <form *ngIf="(accountStatus$ | async)?.dietitian !== undefined; else loading" [formGroup]="form" name="informations-form" (ngSubmit)="submit()">

    <div id="name-wrapper">
      <div id="gender-form" class="form-field">
        <label>Genre</label>
        <select [class.is-invalid]="genderInvalid" class="form-control custom-select"
                id="gender-input" formControlName="gender">
          <option value="" selected disabled>Choisir un genre...</option>
          <option value="WOMAN">Femme</option>
          <option value="MAN">Homme</option>
          <option value="NB">Non binaire</option>
        </select>
        <div class="invalid-feedback">
          Veuillez sélectionner un genre.
        </div>
      </div>
      <div id="first-name-form" class="form-field">
        <label>Prénom</label>
        <input type="text" [class.is-invalid]="firstNameInvalid" class="form-control" placeholder="Prénom"
          id="first-name-input" formControlName="firstName">
        <div class="invalid-feedback">
          Veuillez entrer un prénom valide.
        </div>
      </div>
      <div id="last-name-form" class="form-field">
        <label>Nom</label>
        <input type="text" [class.is-invalid]="lastNameInvalid" class="form-control" id="last-name-input"
          placeholder="Nom" formControlName="lastName">
        <div class="invalid-feedback">
          Veuillez entrer un nom valide.
        </div>
      </div>
    </div>
    <div id="phone-form" class="form-field">
      <label>Téléphone</label>
      <input type="tel" [class.is-invalid]="phoneInvalid" placeholder="+33..." class="form-control" id="phone-input"
        formControlName="phone">
      <div class="invalid-feedback">
        Veuillez entrer un numéro de téléphone valide.
      </div>
    </div>
    <div id="email-form" class="form-field">
      <label>Adresse Email</label>
      <input type="email" [class.is-invalid]="emailInvalid" placeholder="Email" class="form-control" id="email-input"
        formControlName="email">
      <div class="invalid-feedback">
        Veuillez entrer une adresse email valide.
      </div>
    </div>
    <div id="address-form" class="form-field">
      <label>Adresse</label>
      <input type="text" placeholder="Adresse" class="form-control" id="address-input" formControlName="address"
        [class.is-invalid]="addressInvalid">
      <div class="invalid-feedback">
        Veuillez entrer une adresse postale valide.
      </div>
    </div>
    <div id="postal-code-form" class="form-field">
      <label>Code postal</label>
      <input type="text" [class.is-invalid]="postalCodeInvalid" placeholder="Code postal" class="form-control"
        id="postal-code-input" formControlName="postalCode">
      <div class="invalid-feedback">
        Veuillez entrer un code postal valide.
      </div>
    </div>
    <div id="city-form" class="form-field">
      <label>Ville</label>
      <input type="text" [class.is-invalid]="cityInvalid" placeholder="Ville" class="form-control" id="city-input"
        formControlName="city">
      <div class="invalid-feedback">
        Veuillez entrer un nom de ville valide.
      </div>
    </div>
    <div id="country-form" class="form-field">
      <label>Pays</label>
      <select class="form-control form-select" [class.is-invalid]="countryInvalid" id="country-select"
        formControlName="country" aria-label="Sélectionner un pays">
        <option value="" selected disabled>Sélectionner un pays</option>
        <option *ngFor="let featuredCountry of featuredCountries" [title]="featuredCountry?.country_name"
          [attr.aria-label]="featuredCountry?.country_name" [value]="featuredCountry?.alpha2">
          {{featuredCountry?.country_name}}</option>
        <option disabled>──────────</option>
        <option *ngFor="let country of countries" [value]="country.alpha2">{{country.country_name}}</option>
      </select>
      <div class="invalid-feedback">
        Veuillez sélectionner un pays.
      </div>
    </div>

    <div id="status-form" class="form-field d-flex flex-column">
      <label>Statut</label>
      <div>
        <input class="form-check-input mr5px"
               formControlName="status"
               id="dietittian-radio"
               name="status"
               type="radio"
               value="dietitian">
        <label class="form-check-label call-to-action-md" for="dietittian-radio">Je suis diététicien.ne</label>
      </div>
      <div>
        <input class="form-check-input mr5px"
               formControlName="status"
               id="student-radio"
               name="status"
               type="radio"
               value="student">
        <label class="form-check-label call-to-action-md" for="student-radio">Je suis étudiant.e en diététique</label>
      </div>
    </div>

    <div *ngIf="hasRegistrationNumber()" id="registration-number-form" class="form-field">
      <label>Matricule (Adeli/Rpps/Inami/...)</label>
      <input type="text" [class.is-invalid]="postalCodeInvalid" placeholder="Matricule" class="form-control"
             id="registration-number-input" formControlName="registrationNumber">
      <div class="invalid-feedback">
        Veuillez entrer un matricule valide.
      </div>
    </div>

    <div *ngIf="(accountStatus$ | async)?.error as error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <button id="submit-button" type="submit" [disabled]="!form.valid || isLoading" class="btn btn-primary btn-gradient">
      <ng-container *ngIf="isLoading; else saveButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #saveButton>
        Sauvegarder
        <i i-bs name="check" width="20" height="20"></i>
      </ng-template>
    </button>

  </form>
  <ng-template #loading>
    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
  </ng-template>
</div>
